<template>
  <div id="TranshipmentPreview">
    <BreadCrumb :items="breadcrumbItems" />

    <v-row>
      <v-col cols="12">
        <v-card v-if="loading && parameterID" elevation="2" class="py-5 px-5 mt-1 text-center">
          Aguarde, buscando dados
          <div class="mt20"></div>
          <v-progress-linear indeterminate class="mb-0"></v-progress-linear>
        </v-card>
        <v-card v-else elevation="2" class="py-5 mt-1">
          <div class="d-flex justify-space-between px-5 align-center mb-3">
            <h1>Visualizar transbordo</h1>
          </div>

          <v-expansion-panels class="px-5 py-1" accordion>
            <v-expansion-panel class="elevation-1">
              <v-expansion-panel-header color="#f2f2f2" class="px-4">
                <span>Filtrar por</span>
                <template v-slot:actions>
                  <v-icon color="black"> mdi-chevron-down </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="mt-2">
                  <v-col cols="12" sm="3">
                    <v-menu
                      v-model="dateStartMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formattedStartDate"
                          label="Data Inicial"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="startDate" no-title @input="dateStartMenu = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-menu
                      v-model="dateEndtMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formattedEndDate"
                          label="Data Final"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="endDate" no-title @input="dateEndtMenu = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <div class="px-5 mt-5">
            <v-row>
              <v-col cols="12">
                <transhipment-cards :isLoading="isDashboardLoading" :cardsData="dashboardCardsData" /> </v-col
            ></v-row>
            <v-row>
              <v-col cols="12">
                <transhipment-bar-chart
                  :isLoading="isDashboardLoading"
                  :transhipments="dashboardTranshipments"
                  transhipmentCities
                /> </v-col
            ></v-row>

            <v-row>
              <v-col cols="12" lg="6">
                <transhipment-quantity-bar-chart :transhipmentId="parameterID" :date="filterDateObject" />
                <transhipment-evaluation :transhipmentId="parameterID" class="mt-6" />
              </v-col>
              <v-col cols="12" lg="6">
                <transhipment-financial-bar-chart :transhipmentId="parameterID" :date="filterDateObject" />
                <transhipment-couriers :transhipmentId="parameterID" class="mt-6" />
              </v-col>
            </v-row>
          </div>

          <div class="px-5 mt-4">
            <v-row> </v-row>
          </div>
          <div class="px-5 mt-4">
            <v-row>
              <v-col cols="12">
                <v-card class="py-5">
                  <transhipment-preview-data :transhipmentId="parameterID" />
                </v-card>
              </v-col>
            </v-row>
          </div>

          <v-row class="pa-5 pb-2">
            <v-col cols="12">
              <v-card class="pa-5">
                <transhipment-unfinished-stops :transhipmentId="parameterID" />
              </v-card>
            </v-col>
          </v-row>

          <v-form @submit.prevent="submit">
            <v-row class="px-5">
              <v-col cols="12" class="d-flex justify-end">
                <v-btn large color="info" :class="onlyView ? '' : 'mr-5'" @click="cancel()">
                  {{ onlyView ? 'VOLTAR' : 'CANCELAR' }}
                </v-btn>
                <v-btn v-if="!onlyView" large color="success" @click="submit()" :loading="loadingToCreate">
                  SALVAR
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <MessagesError :type="errorsType" :errors="errors" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BreadCrumb from '../../../components/BreadCrumb.vue';
import TranshipmentCards from '../../../components/Transhipment/TranshipmentCards.vue';
import TranshipmentBarChart from '../../../components/Transhipment/TranshipmentBarChart.vue';
import TranshipmentQuantityBarChart from '../../../components/Transhipment/TranshipmentQuantityBarChart.vue';
import TranshipmentFinancialBarChart from '../../../components/Transhipment/TranshipmentFinancialBarChart.vue';
import TranshipmentEvaluation from '../../../components/Transhipment/TranshipmentEvaluations.vue';
import MessagesError from '../../../components/MessagesError.vue';
import TranshipmentUnfinishedStops from '../../../components/Transhipment/TranshipmentUnfinishedStops.vue';
import TranshipmentCouriers from '../../../components/Transhipment/TranshipmentCouriers.vue';
import TranshipmentPreviewData from '../../../components/Transhipment/TranshipmentPreviewData.vue';

export default {
  name: 'TranshipmentPreview',

  components: {
    BreadCrumb,
    MessagesError,
    TranshipmentCards,
    TranshipmentBarChart,
    TranshipmentEvaluation,
    TranshipmentUnfinishedStops,
    TranshipmentCouriers,
    TranshipmentPreviewData,
    TranshipmentQuantityBarChart,
    TranshipmentFinancialBarChart
  },
  data: () => ({
    dateStartMenu: false,
    dateEndtMenu: false,
    startDate: '',
    endDate: '',
    isDashboardLoading: true,
    dashboardCardsData: null,
    dashboardTranshipments: [],
    loadingToCreate: false,
    errors: [],
    errorsType: null,
    typeTranshipment: [
      {
        text: 'Empresa',
        value: 'enterprise'
      },
      {
        text: 'Pessoal',
        value: 'personal'
      }
    ],
    typeTranshipmentSelected: 'enterprise',
    isValidPassword: false,
    loadingCity: false,
    isValidDocument: false,
    loading: true,
    generalData: {
      name: null,
      tradingName: null,
      cpf: null,
      cnpj: null,
      phone: null,
      cellphone: null
    },
    addressData: {
      cep: null,
      neighborhood: null,
      street: null,
      state: null,
      cityId: null,
      number: null,
      complement: null
    },
    bankData: {
      bankName: null,
      agency: null,
      account: null,
      cpfOrCnpjHolder: null,
      pixKey: null,
      isHolder: true
    },
    accessData: {
      email: null,
      password: null,
      confirmPassword: null
    },
    rules: [(value) => !!value || 'Required.']
  }),
  computed: {
    ...mapGetters('AdressStore', ['getStates', 'getCities']),
    breadcrumbItems() {
      return [
        {
          text: 'Início',
          disabled: false,
          to: '/start'
        },
        {
          text: 'Lista de transbordos',
          disabled: false,
          exact: true,
          to: '/transhipments'
        },
        {
          text: this.namePage,
          disabled: true,
          to: '/new-transhipment'
        }
      ];
    },
    disableCity() {
      if (this.onlyView) {
        return true;
      }

      return !this.addressData.state;
    },
    onlyView() {
      return this.$route.name === 'ViewTranshipment';
    },
    namePage() {
      if (this.parameterID) {
        if (this.onlyView) {
          return 'Visualizar transbordo';
        } else {
          return 'Editar transbordo';
        }
      }

      return 'Novo transbordo';
    },
    isPersonal() {
      return this.typeTranshipmentSelected === 'personal';
    },
    parameterID() {
      return this.$route.params.id;
    },
    isCompanyInRoute() {
      return Boolean(Number(this.$route.params.type));
    },
    formattedStartDate() {
      if (!this.startDate) return '';
      const [year, month, day] = this.startDate.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedEndDate() {
      if (!this.endDate) return '';
      const [year, month, day] = this.endDate.split('-');
      return `${day}/${month}/${year}`;
    },

    filterDateObject() {
      return this.startDate !== '' && this.endDate !== '' ? { startDate: this.startDate, endDate: this.endDate } : null;
    }
  },

  watch: {
    loading: {
      handler() {
        this.fetchTranshipmentsDashboardDataByTranshipmentId();
      }
    },

    startDate: {
      handler() {
        if (this.endDate)
          this.fetchTranshipmentsDashboardDataByTranshipmentId({
            startDate: this.startDate,
            endDate: this.endDate,
            transhipmentId: this.parameterID
          });
      }
    },
    endDate: {
      handler() {
        if (this.startDate)
          this.fetchTranshipmentsDashboardDataByTranshipmentId({
            startDate: this.startDate,
            endDate: this.endDate,
            transhipmentId: this.parameterID
          });
      }
    }
  },

  mounted() {
    this.fetchAllStates();

    if (this.parameterID) {
      this.transhipmentEdit();
    }
  },
  methods: {
    ...mapActions('TranshipmentStore', [
      'createTranshipment',
      'editTranshipment',
      'fetchTranshipmentByID',
      'getTranshipmentsDashboardDataByTranshipmentId'
    ]),
    ...mapActions('AdressStore', ['fetchStates', 'fetchCities']),
    setValidDocument(bool = true) {
      this.isValidDocument = bool;

      if (bool === true) {
        setTimeout(() => {
          this.isValidDocument = false;
        }, 3000);
      }
    },

    async fetchTranshipmentsDashboardDataByTranshipmentId(
      params = { startDate: '', endDate: '', transhipmentId: this.parameterID }
    ) {
      try {
        this.isDashboardLoading = true;
        const { onTime, late, openLate, openOnTime, getCountNfesByTranshipmentDto } =
          await this.getTranshipmentsDashboardDataByTranshipmentId(params);
        this.dashboardCardsData = { onTime, late, openLate, openOnTime };
        this.dashboardTranshipments = getCountNfesByTranshipmentDto;
      } catch (error) {
        console.error(error);
      } finally {
        this.isDashboardLoading = false;
      }
    },

    checkForm() {
      if (
        this.generalData.name === null ||
        this.generalData.phone === null ||
        this.generalData.cellphone === null ||
        (this.typeTranshipmentSelected === 'personal' && this.generalData.cpf === null) ||
        (this.typeTranshipmentSelected === 'enterprise' && this.generalData.tradingName === null) ||
        (this.typeTranshipmentSelected === 'enterprise' && this.generalData.cnpj === null) ||
        this.addressData.cep === null ||
        this.addressData.neighborhood === null ||
        this.addressData.street === null ||
        this.addressData.state === null ||
        this.addressData.cityId === null ||
        this.addressData.number === null ||
        this.bankData.bankName === null ||
        this.bankData.agency === null ||
        this.bankData.account === null ||
        this.accessData.password === null ||
        this.accessData.confirmPassword === null
      ) {
        return false;
      } else {
        return true;
      }
    },
    async submit() {
      if (!this.checkForm()) {
        this.errors = ['Campos inválidos! Verifique se você não esqueceu algum campo obrigatório.'];
        this.errorsType = 'info';
        return;
      }
      this.loadingToCreate = true;

      let body = {
        type: this.typeTranshipmentSelected,
        params: {
          ...this.generalData,
          ...this.accessData,
          addressData: this.addressData,
          bankData: this.bankData
        }
      };

      if (this.parameterID) {
        body.params.id = this.parameterID;
      }

      try {
        const status = this.parameterID ? await this.editTranshipment(body) : await this.createTranshipment(body);

        if (status.success) {
          this.success = true;
          this.$router.push('/transhipment');
        } else {
          this.errors = status.errors;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingToCreate = false;
      }
    },
    async fetchAllRoles() {
      try {
        await this.fetchRoles();
      } catch (err) {
        console.error(err);
      }
    },
    async fetchAllStates() {
      try {
        await this.fetchStates();
      } catch (err) {
        console.error(err);
      }
    },
    async fetchCitiesByID() {
      this.loadingCity = true;
      try {
        await this.fetchCities(this.addressData.state);
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingCity = false;
      }
    },
    cancel() {
      this.$router.back();
    },
    setValidPassword(bool = true) {
      this.isValidPassword = bool;

      if (bool === true) {
        setTimeout(() => {
          this.isValidPassword = false;
        }, 3000);
      }
    },
    async transhipmentEdit() {
      this.loading = true;
      try {
        const data = await this.fetchTranshipmentByID({
          id: this.parameterID,
          type: this.isCompanyInRoute
        });

        this.typeTranshipmentSelected = this.isCompanyInRoute ? 'enterprise' : 'personal';

        this.generalData.name = this.isCompanyInRoute ? data.companyName : data.name;

        if (this.isCompanyInRoute) {
          this.generalData.tradingName = data.tradingName;
        }

        this.generalData.cnpj = data.cnpj || null;
        this.generalData.cpf = data.cpf || null;

        this.generalData.phone = data.phones[0];
        this.generalData.cellphone = data.phones[1];

        this.addressData.cep = data.address.cep;
        this.addressData.neighborhood = data.address.neighborhood;
        this.addressData.street = data.address.street;
        this.addressData.cityId = data.address.cityId;
        this.addressData.state = data.address.stateId;

        this.loadingCity = true;
        try {
          await this.fetchCities(data.address.stateId);
        } catch (err) {
          console.error(err);
        } finally {
          this.loadingCity = false;
        }

        this.addressData.number = data.address.number;
        this.addressData.complement = data.address.complement;

        this.bankData.bankName = data.bankData.bankName;
        this.bankData.agency = data.bankData.agency;
        this.bankData.account = data.bankData.account;
        this.bankData.cpfOrCnpjHolder = data.bankData.cpfOrCnpjHolder;
        this.bankData.pixKey = data.bankData.pixKey;
        this.bankData.isHolder = data.bankData.isHolder;

        this.accessData.email = data.email;
        this.accessData.password = data.password;
        this.accessData.confirmPassword = data.confirmPassword;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">
#new-transhipment {
}
</style>
